import React, { Component } from "react";
import { color } from "../common/constants";
import { renderImg } from "./icons/img";
import { getImgPath, handleImgError } from "./helper";
import { RadioCheckout } from "./input/radio";

class LineInpDrop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focus: false,
            blur: false,
            sel: {},
            searchQuery: "",
            currentItmeIndex: -1,
            passtabIndexRArr: [20, 27, 34, 41, 48, 55],
            checktabIndexRArr: [69, 76, 83, 90, 97, 104],
        };
        this.inputRef = React.createRef();
    }


    componentDidMount() {
        if (this.props.tab == 17 && this.props.dropType == 'return_concession') {
            let target = document.querySelector('[tabindex="17"]');
            if (target) {
                this.props.tabHandler && this.props.tabHandler();
                this.setState({ focus: true })
            }

            setTimeout(() => {
                if (this.inputRef && this.inputRef.current) {
                    this.inputRef.current.focus();
                    this.setState({ focus: false })
                }
            }, 3000)
        }
        if(this.props.selAutoConRet){
            this.props.selAutoConRet();
        }
    }

    getBorderColor = () => {

        if (this.state.focus) {
            return color.blue;
        }

        // if (this.state.blur) {
        if (
            this.props.validation === "email" && this.props.value &&
            !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value)
        ) {
            return "red";
        }
        if (
            this.props.validation === "gstno" &&
            !/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
                this.props.value
            )
        ) {
            return "red";
        }
        if (
            this.props.validation === "mobile" && this.props.value &&
            (this.props.value < 6000000000 || (this.props.value + "").length !== 10)
        ) {
            return "red";
        }
        return "#ddd";
    };

    getlabelColor = () => {

        if (this.state.focus) {
            return color.blue;
        }

        // if (this.state.blur) {
        if (
            this.props.validation === "email" && this.props.value &&
            !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value)
        ) {
            return "red";
        }
        if (
            this.props.validation === "gstno" &&
            !/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
                this.props.value
            )
        ) {
            return "red";
        }
        if (
            this.props.validation === "mobile" && this.props.value &&
            (this.props.value < 6000000000 || (this.props.value + "").length !== 10)
        ) {
            return "red";
        }
        return "#000";
    };

    handleBlur = () => {
        setTimeout(() => {
            this.setState({ focus: false, blur: true })
        }, 3000)
        if (typeof this.props.onBlur === 'function') {
            this.props.onBlur();
        }
    }



    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    }

    handleEnterVal = (e, type) => {
        e && e.stopPropagation();
        let searchQuery = this.state.searchQuery;
        let data = this.props.data;
        if (searchQuery && searchQuery.length > 0) {
            let selVal = data.filter(option => option.toLowerCase().includes(searchQuery.toLowerCase()));
            if (selVal && selVal.length > 0) {
                this.props.handleDropData(0, this.props.dropType, this.props.seatNo, this.props.seatsData, selVal[0])
            }
        } else {
            if (type !== 'onward_country' && type !== 'return_country' && data && data.length > 0) {
                this.props.handleDropData(0, this.props.dropType, this.props.seatNo, this.props.seatsData, data[0])
            }
        }
        this.props.toggleDrop();
    };

    focusItem = (items, index) => {
        items.forEach((item, idx) => {
            if (idx === index) {
                item.classList.add('focused');
                item.focus(); // Focus on the item
                item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            } else {
                item.classList.remove('focused');
            }
        });
    }

    handleKeyDown = (event, type) => {
        const items = document.querySelectorAll('.pass--inp--drop .ddn');
        let currentItmeIndex = this.state.currentItmeIndex;
        let passtabIndexRArr = this.state.passtabIndexRArr;
        let checktabIndexRArr = this.state.checktabIndexRArr;
        let { NoOfSeats } = this.props;
        // this.setState({ currentItmeIndex })

        if (event.key === 'Enter') {
            let active = document.activeElement;
            // Find the next focusable element
            let allElements = document.querySelectorAll('[tabindex]');
            let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 1);
            if (type === 'return_country') {
                target = Array.from(allElements).find(el => {
                    if (passtabIndexRArr[NoOfSeats - 1] == (active.tabIndex) || checktabIndexRArr[NoOfSeats - 1] == (active.tabIndex))
                        return el.tabIndex === active.tabIndex + 1;
                    else
                        return el.tabIndex === active.tabIndex + 4;
                }
                );
            }
            // Focus the next element if it exists
            this.handleEnterVal(event, type)

            if (currentItmeIndex > -1) {
                items[currentItmeIndex].click();
            }
            if (target) {
                target.focus();
            }
        }

        if (event.key === 'Tab') {
            let allFocusableElements = Array.from(document.querySelectorAll('[tabindex]'));
            let activeElement = document.activeElement;
            let currentIndex = allFocusableElements.indexOf(activeElement);

            if (currentIndex > 0) {
                // Move focus to the previous element
                allFocusableElements[currentIndex - 1].focus();
            } else {
                // If it's the first element, loop back to the last element
                allFocusableElements[allFocusableElements.length - 1].focus();
            }
            this.props.toggleDrop();
        }

        if (event.key === 'Tab' && event.shiftKey) {
            let allFocusableElements = Array.from(document.querySelectorAll('[tabindex]'));
            let activeElement = document.activeElement;
            let currentIndex = allFocusableElements.indexOf(activeElement);

            if (currentIndex > 0) {
                // Move focus to the previous element
                allFocusableElements[currentIndex - 1].focus();
            } else {
                // If it's the first element, loop back to the last element
                allFocusableElements[allFocusableElements.length - 1].focus();
            }
            this.props.toggleDrop();
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            // Move focus to the first item if no item is currently focused
            if (currentItmeIndex < items.length - 1) {
                currentItmeIndex++;
            } else {
                currentItmeIndex = 0;
            }
            this.focusItem(items, currentItmeIndex);
            this.setState({ currentItmeIndex })

        } else if (event.key === 'ArrowUp') {
            if (currentItmeIndex > 0) {
                currentItmeIndex--;
            }
            this.focusItem(items, currentItmeIndex);
            this.setState({ currentItmeIndex })
        }
    }

    searchOptions = (type) => {
        let placeholder = "";
        if (type === 'onward_gender' || type === 'return_gender') {
            placeholder = 'Search Gender';
        }
        if (type === 'onward_concession' || type === 'return_concession') {
            placeholder = 'Search Concession Type';
        }
        if (type === 'onward_idCardType' || type === 'return_idCardType')
            placeholder = 'Search ID Type';
        if (type === 'onward_country' || type === 'return_country')
            placeholder = 'Search Country';
        return (
            <div className="checkout--srch--drop">
                {renderImg('SearchDropIcon')}
                <input
                    ref={this.inputRef}
                    className="checkout--drop--inp"
                    type="text"
                    id={'searchInput'}
                    autoComplete="off"
                    placeholder={`${placeholder}`}
                    autoFocus={true}
                    tabIndex={this.props.tab}
                    value={this.state.searchQuery}
                    onChange={this.handleSearchChange}
                    onKeyDown={(e) => this.handleKeyDown(e, type)}
                />
            </div>
        )
    }


    render() {
        let dropData = this.props.data;
        let { searchQuery } = this.state;

        dropData = dropData.filter(item =>
            searchQuery ? item.toLowerCase().includes(searchQuery.toLowerCase()) : item
        );

        let data = this.props.data;
        let highlightVal = false;
        if (searchQuery && searchQuery.length > 0) {
            let selVal = data.filter(option => option.toLowerCase().includes(searchQuery.toLowerCase()));
            if (selVal && selVal.length > 0) {
                highlightVal = true;
            }
        }
        return (
            <div style={{ ...this.props.style, position: "relative" }}>
                <input
                    type={this.props.type}
                    value={this.props.value}
                    onFocus={() => {
                        this.props.tabHandler && this.props.tabHandler();
                        this.setState({ focus: true, blur: false, searchQuery: "" })
                    }}
                    onBlur={() => {
                        this.handleBlur()
                    }}
                    onClick={this.props.onClick}
                    tabIndex={this.props.tab}
                    name={this.props.name}
                    dropType={this.props.dropType}
                    autoComplete="none"
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                    style={{
                        background: "transparent",
                        border:
                            !this.state.focus && !this.state.blur
                                ? "1px solid"
                                : "2px solid ",
                        outline: 0,
                        width: "100%",
                        padding: this.props.isImg ? "20px 0 5px 40px" : "18px 10px",
                        borderColor: this.getBorderColor(),
                        transition: "0.3s ease",
                        borderRadius: this.props.InputRadius || "6px",
                        height: this.props.InputHeight || "45px",
                        textOverflow: 'ellipsis',
                        fontSize: this.props.dropType === 'onward_concession' || this.props.dropType === 'return_concession' ? 'smaller' : 'inherit',
                    }}
                    className={`${this.state.focus || this.props.value && this.props.value.toString().length > 0 ? 'active' : ''}`}

                />
                <label
                    style={{
                        position: "absolute",
                        left: this.props.isImg ? "40px" : "7px",
                        fontSize:
                            this.state.focus || (this.props.value + "").length > 0
                                ? "12px"
                                : "inherit",
                        bottom:
                            this.state.focus || (this.props.value + "").length > 0
                                ? "38px"
                                : "15px",
                        transition: "0.3s ease",
                        pointerEvents: "none",
                        color: this.state.focus ? color.blue : this.getlabelColor(),
                        padding: "0 5px",
                        background: this.state.focus || (this.props.value + "").length > 0 ? "#fff":"",
                    }}

                    className={`${this.state.focus || this.props.value && this.props.value.toString().length > 0 ? 'active' : ''}`}
                >
                    {this.props.placeholder}
                </label>
                <img
                    src={getImgPath('/img/inpdropIcon.png')} onError={handleImgError}
                    style={{ position: "absolute", right: '10px', bottom: '18px', pointerEvents: 'none' }}
                />
                {this.props.openDrop &&
                    <div className={`pass--inp--drop ${this.props.dropType}`}>
                        {
                            (this.props.dropType === 'onward_gender' || this.props.dropType === 'return_gender' ||
                                this.props.dropType === 'onward_concession' || this.props.dropType === 'return_concession' ||
                                this.props.dropType === 'onward_idCardType' || this.props.dropType === 'return_idCardType' || this.props.dropType === 'onward_country' || this.props.dropType === 'return_country')
                                ? this.searchOptions(this.props.dropType)
                                : ""
                        }
                        {dropData && dropData.length > 0 && dropData.map((el, index) =>
                            <React.Fragment key={index}>
                                <div className={highlightVal ? 'ddn active' : (el === this.props.value) ? 'ddn selected' : 'ddn'} style={{ display: 'flex', alignItems: 'center', position: 'relative', borderBottom: '1px solid rgba(0,0,0, 0.20)' }} onClick={() => {
                                    this.props.handleDropData(index, this.props.dropType, this.props.seatNo, this.props.seatsData, el)
                                }}>
                                    {/* <RadioCheckout active={el === this.props.value} /> */}
                                    <div className={el === this.props.value ? 'active' : ''} style={{ padding: '0', marginLeft: '8px' }} tabIndex={-1}>{el}</div>
                                </div>

                            </React.Fragment>
                        )}
                    </div>
                }
            </div>
        );
    }
}

export default LineInpDrop;